module.exports = __webpack_public_path__ + "img/7.df1bf37a.jpg";